import { render, staticRenderFns } from "./CorrectiveActionAttachmentsHandler.vue?vue&type=template&id=08ebe8b9&scoped=true&"
import script from "./CorrectiveActionAttachmentsHandler.vue?vue&type=script&lang=js&"
export * from "./CorrectiveActionAttachmentsHandler.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveActionAttachmentsHandler.vue?vue&type=style&index=0&id=08ebe8b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebe8b9",
  null
  
)

export default component.exports